module.exports = __webpack_public_path__ + "assets/d7f0257a6df8c852fcb20230a67835cc.mp3";